import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import TbExpenseDetail from '@/types/table/tbExpenseDetail';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface TbExpenseDetailData extends TbExpenseDetail {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class TbExpenseDetailController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<TbExpenseDetailData>>(API_CONTEXT + '/upms/tbExpenseDetail/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<TbExpenseDetailData>(API_CONTEXT + '/upms/tbExpenseDetail/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/tbExpenseDetail/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/tbExpenseDetail/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/tbExpenseDetail/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpenseDetail/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpenseDetail/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpenseDetail/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/tbExpenseDetail/deleteBatch', params, httpOptions);
  }
}
